var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.block)?_c('p',{staticClass:"is-size-7 hero",class:_vm.classColor},[_vm._v(" "+_vm._s(_vm.$t('plan.blocks.'+_vm.block.name.toLowerCase()))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }